import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLogged, setIsLogged] = useState(false);
  const [authToken, setAuthToken] = useState(null);
  const [userInfo, setUserInfo] = useState(() => {
    const savedUserInfo = sessionStorage.getItem('userInfo');
    return savedUserInfo ? JSON.parse(savedUserInfo) : null;
  });

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    setIsLogged(!!token);
    setAuthToken(token);
  }, []);

  const login = (token, user) => {
    sessionStorage.setItem('token', token);
    setUserInfo(user);
    sessionStorage.setItem('userInfo', JSON.stringify(user));
    setIsLogged(true);
    setAuthToken(token);
  };

  const logout = () => {
    setIsLogged(false);
    setAuthToken(null);
  };

  return (
    <AuthContext.Provider value={{ userInfo, authToken, isLogged, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
